import "./02_footer.css"

export default function Footer() {
    return (
        <div>
            <div className="Footer-MainSection-Flex">
                <div className="Footer-MainSection-PageLinks">
                    <a className="Text-Footer-Main" href="/">home</a>
                    <a className="Text-Footer-Main" href="/about">about</a>
                    <a className="Text-Footer-Main" href="/our-process">our process</a>
                    <a className="Text-Footer-Main" href="/hearing-solutions">hearing solutions</a>
                    <a className="Text-Footer-Main" href="/hearing-aids-products">types of hearing aids</a>
                </div>
                <div className="Footer-MainSection-BlogLinks">
                    <a className="Text-Footer-Subs" href="#">blog dashboard</a>
                    <a className="Text-Footer-Subs" href="#">blog 1</a>
                </div>
                <div className="Footer-MainSection-ContactLinks">
                    <a className="Text-Footer-Subs" href="tel:8080282828">+91 8080282828</a>
                    <a className="Text-Footer-Subs" href="#">abc@gmail.com</a>
                    <p className="Text-Footer-Subs">
                        53, Shubh Commercial, Opp ESIS hospital, Above Janta Restaurant & Bar,Akurli Road Kandivali East, Mumbai 400101
                    </p>
                    <button><a className="Text-Footer-Buttons" href="/contact">contact us</a></button>
                    <button><a className="Text-Footer-Buttons" href="/appointment">book an appointment</a></button>
                </div>
            </div>
            <div className="Footer-SubSection-Flex">
                <p className="Text-Footer-Doc" >easyhear.in 	&copy;2026</p>
                <div className="Footer-SubSection-Side">
                    <a className="Text-Footer-Doc" href="#">Terms & Conditions</a>
                    <a className="Text-Footer-Doc" href="#">Privacy Policies</a>
                </div>
            </div>
        </div>
    );
}